import fetch from '../fetch';
import utils from '../../utils';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {
        type: 'selection'
    },
    {
        key:'$index', 
        label: '序号', 
        width: 75
    },
    {
        key:'className', 
        label: '班级', 
        width: 150
    },
    {
        key:'orgName', 
        label: '班级所属部门', 
        width: 130
    },
    {
        key:'avgScore', 
        label: '平均分', 
        width: 70
    },
    {
        key:'count', 
        label: '评学次数', 
        width: 120
    },
    {
        key:'termName', 
        label: '所属学期', 
        width: 130
    },
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`eval/teacher/class/collect/list?${params.join('&')}`, keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(response => (Object.assign({
        result: response.data.dataList,
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        meta: response.meta,
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh
}
